import { createStore, applyMiddleware } from 'redux';
import confirmAttendeesReducer from '../reducers/confirmAttendeesReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(confirmAttendeesReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
